"use client";
import { getTranslation } from "@/i18n/get-translation";
import AngleDown from "@/icons/angleDown.svg";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { IFaqsData, THotTopicsResponse } from "@/types/faq.type";
import React from "react";
import { getHotTopics } from "@/services/faq-service";

const FaqsData: IFaqsData[] = [];

interface IrelatedSearchFaqs {
  id: number;
  title?: string;
}

const relatedSearchFaqs: IrelatedSearchFaqs[] = [
  {
    id: 1,
    title: "theInformationWeCollect",
  },
  {
    id: 2,
    title: "howOurServicesAllow",
  },
  {
    id: 3,
    title: "cookiesTrackingAnalytics",
  },
  {
    id: 4,
    title: "interestBasedAdvertising",
  },
  {
    id: 5,
    title: "thirdPartyCollection",
  },
  {
    id: 6,
    title: "testimonialsCommentsReviews",
  },
  {
    id: 7,
    title: "dataSecurity",
  },
  {
    id: 8,
    title: "yourChoices",
  },
  {
    id: 9,
    title: "childrensPrivacy",
  },
  {
    id: 10,
    title: "policyChanges",
  },
  {
    id: 11,
    title: "contactUs",
  },
];

interface IFAQsSection {
  locale: string;
}

export default function FaqsSearchResults({ locale }: IFAQsSection) {
  const [hotTopics, setHotTopics] = React.useState<IFaqsData[]>();
  const t = getTranslation(locale, "faqsSearchPage");

  const getHotTopicsData = () => {
    getHotTopics("en").then((response: THotTopicsResponse) => {
      setHotTopics(response.data.attributes.faqs.data);
    });
  };

  React.useEffect(() => {
    getHotTopicsData();
  }, []);
  return (
    <section className="relative max-w-400 w-full mx-auto flex lg:flex-row flex-col justify-start items-start lg:gap-0 gap-6 xl:px-40 lg:px-20 px-0 lg:pt-6 pb-14">
      <div className=" lg:flex hidden lg:flex-[1_1_25%] flex-col justify-start items-start text-left lg:pt-20 pt-0 pr-4">
        <h3 className="xl:text-2xl lg:text-xl text-lg   font-normal text-primary-800 mb-6">
          {t("relatedSearches")}
        </h3>
        <ul className="flex justify-start items-start flex-col text-primary-700 gap-3 font-light xl:text-xl lg:text-lg text-base">
          {hotTopics &&
            hotTopics.map((item: IFaqsData) => (
              <li key={item.id}>
                <a href={`/${locale}/faq/${item.attributes.slug}`}>
                  {item.attributes.title}
                </a>
              </li>
            ))}
        </ul>
      </div>
      <Disclosure
        as="div"
        className="flex lg:hidden flex-col w-full items-stretch justify-start bg-primary-500 border-none px-7 py-4 text-left focus:outline-none"
      >
        {({ open }) => (
          <>
            <DisclosureButton className="flex w-full items-center justify-between focus:outline-none bg-primary-500">
              <span className="text-xl font-normal text-primary-800">
                {t("relatedSearches")}
              </span>
              <div
                className={`bg-primary-400-25 rounded-full w-10 h-10 flex items-center justify-center text-primary-700 transition ${
                  open && "rotate-180 bg-primary-700 text-white"
                }`}
              >
                <AngleDown className="w-4" />
              </div>
            </DisclosureButton>
            <DisclosurePanel
              as="div"
              className="pt-4 pb-2 text-lg text-gray-800 font-light  "
            >
              <span>
                <ul className="flex justify-start items-start flex-col text-primary-700 gap-3 font-light xl:text-xl lg:text-lg text-base">
                  {relatedSearchFaqs.map((item: IrelatedSearchFaqs) => (
                    <li key={item.id}>
                      <a href="#">{t(item.title)}</a>
                    </li>
                  ))}
                </ul>
              </span>
            </DisclosurePanel>
          </>
        )}
      </Disclosure>
      <div className="lg:flex-[1_1_75%] flex text-left flex-col justify-start items-stretch px-7 lg:pr-0 lg:pl-24 lg:pt-16 pt-6 border-l">
        <div className="md:mb-12 mb-8">
          <span className="xl:text-xl lg:text-lg text-base font-light text-primary-800 ">
            {t("showing")} 1 - 10 {t("outOf")} 13 {t("resultsFor")} “Lucy
            Dashboard”
          </span>
        </div>
        <div className="flex flex-col justify-start items-start gap-8">
          {FaqsData.map((item: IFaqsData) => (
            <article
              className="flex flex-col justify-start items-start gap-3"
              key={item.id}
            >
              <h3 className="xl:text-2xl lg:text-xl text-lg   font-normal text-primary-700">
                <a href={`/${locale}/${item.attributes.slug}`}>
                  {item.attributes.title}
                </a>
              </h3>
              <p className="font-light lg:text-lg text-base text-primary-800  ">
                {item.attributes.content}
              </p>
              <ul className="flex list-none pl-0 flex-row gap-1.5 overflow-auto customOverflow">
                <li>
                  <button className="block min-w-18 w-full rounded-lg bg-primary-500 hover:bg-primary-700 hover:text-white px-4 py-1 text-base font-normal text-primary-800 whitespace-nowrap">
                    Features
                  </button>
                </li>
                <li>
                  <button className="block min-w-18 w-full rounded-lg bg-primary-500 hover:bg-primary-700 hover:text-white px-4 py-1 text-base font-normal text-primary-800 whitespace-nowrap">
                    Lucy
                  </button>
                </li>
                <li>
                  <button className="block min-w-18 w-full rounded-lg bg-primary-500 hover:bg-primary-700 hover:text-white px-4 py-1 text-base font-normal text-primary-800 whitespace-nowrap">
                    Documentation{" "}
                  </button>
                </li>
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
